import React,{useEffect} from "react";


const MssPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-semibold mb-6">MESAFELİ SATIŞ SÖZLEŞMESİ </h1>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">MADDE – 1 KONU </h2>
        <p>
        Bu sözleşmenin konusu, Satıcı’nın Alıcı’ya (Tüketici’ye) satışını yaptığı, 6502 sayılı 
Tüketicilerin Korunması Hakkındaki Kanun ve Mesafeli Sözleşmeler Uygulama Esas ve 
Usulleri Hakkında Yönetmelik hükümleri ile diğer yasal hükümler uyarınca tarafların hak 
ve yükümlülüklerinin belirlenmesidir.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">MADDE – 2 SÖZLEŞME’NİN KURULMASI </h2>
        <p>
        2.1 Alıcı, sözleşmeyi anladığını, haklarının ve yükümlülüklerinin bilincinde olduğunu 
kabul eder. 
        </p>
        <p>
        2.2 Satıcı ve Alıcı, sözleşme ile kararlaştırılan edimler arasında hiçbir oransızlık 
bulunmadığını ve karşılıklı edimlerin işin niteliğine uygun olduğunu, sözleşme konusuna 
giren işlemler kapsamında herhangi bir tecrübesizliklerinin bulunmadığını kabul 
ederler.
        </p>
        <p>
        2.3 Alıcı, sözleşme kapsamında yer alan işlemlerin kendi menfaatine uygun olduğu 
konusunda tam bir kanaate vardığını ve tüm şartlara kendi özgür iradesiyle, hiçbir 
güçlük veya sıkıntı içinde olmadan, düşünerek, isteyerek ve bilerek uyacağını kabul 
eder.
        </p>
        <p>
        2.4 Satıcı ve Alıcı, sözleşmenin hükümlerinin haksız şart sayılabilecek bir özellik 
taşımadığını, menfaatler dengesi bakımından bir haksızlık olmadığını kabul eder. 
        </p>
        <p>
        2.5 İşbu sözleşme, ekleri ve https://celiktuhafiye.com/ üzerinden yapılan işlemler 
kapsamında tedarik edilen bilgiler ve elektronik vasıtalarla onaylanan konular 
Kampanyalı Satışlara İlişkin Uygulama Usul ve Esasları Hakkında Yönetmelik’in 6. 
maddesinin gerekliliklerine karşılık gelmektedir.
        </p>
        <p>
        2.6 İşbu sözleşme hükümleri, Tüketici Sözleşmelerindeki Haksız Şartlar Hakkında 
Yönetmelik hükümleri uyarınca herhangi bir haksız şart içermemektedir. Hükümler 
dürüstlük ve iyi niyet kuralına aykırılık teşkil etmemekte olup, tüketicinin korunması 
mevzuatına uygun olarak hazırlanmıştır. 
        </p>
        <p>
        2.7 İşbu sözleşme hükümleri, 6098 sayılı Türk Borçlar Kanunu hükümleri de dikkate 
alınarak hazırlanmıştır. Türk Borçlar Kanunu’nun 21. maddesinde öngörülen bağlayıcılık 
ve içerik denetimi Alıcı tarafından yapılmıştır. İşbu sözleşme hükümlerinden hiçbiri, 
işbu sözleşmenin niteliğine ve işin özelliğine yabancı (şaşırtıcı şartlar) nitelik taşımaz. 
İşbu sözleşme hükümleri açık ve anlaşılır bir şekilde yazılmış olup birden çok anlamı 
ifade etmemektedir.
        </p>

      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">MADDE – 3 SATICI BİLGİLERİ</h2>

        <ul className="list-disc pl-6">
          <li>Unvan: ÇELİK TUHAFİYE</li>
          <li>Adres: Akmescit Mahallesi Terakki Sokak No: 3 A</li>
          <li>Telefon: 05428930718</li>
          <li>Faks: 02722143272</li>
          <li>E-Posta: selimcelikafyon@gmail.com</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">MADDE – 4 İADE VE GARANTİ KOŞULLARI </h2>
        <p>
        Kargoyu teslim alırken koli içini kontrol ediniz. Ürünlerde hasar veya eksik varsa, kargo 
personelinden tutanak tutmasını isteyiniz. Teslimi yapılmış bir sipariş için kargo 
personelinin tüm sorumluluğunu yerine getirmiş olduğunu unutmayınız. Sözleşme 
konusu ürün, ALICI'dan başka bir kişi/kuruluşa teslim edilecekse, teslim edilecek 
kişi/kuruluşun teslimatı kabul etmemesinden SATICI sorumlu tutulamaz. Kargo 
firmasının, ürünü ALICI’ya teslimi aşamasında karşılaşacağı her türlü sorun nedeniyle, 
siparişi verilen ürünün ALICI’ya teslim edilememesinden dolayı SATICI sorumlu 
tutulamaz. 
SATICI, sözleşme konusu ürünün sağlam, eksiksiz, siparişte belirtilen niteliklere uygun 
ve varsa garanti belgeleri ve kullanım kılavuzları ile teslim edilmesinden sorumludur. 
Teslim almış olduğunuz siparişte yanlış, eksik veya kusurlu bir ürün olması halinde 
değişim ve iade hakkınızı kullanabilirsiniz. 
Siparişiniz ile ilgili memnuniyetsizliğiniz olduğunda bize selimcelikafyon@gmail.com 
mail adresinden sipariş numaranızı belirterek e-posta gönderebilir veya telefon 
hattımızdan (05428930718) ulaşabilirsiniz. 
Aldığınız ürünü ambalajını açmadan, tahrip etmeden, ürünü kullanmadan ve daha 
sonra tekrar satışına engel olmayacak şekilde, teslim tarihini geçirmeden teslim 
aldığınız şekliyle iade edebilirsiniz. İade kargonuz firmamıza teslim edilince, sipariş 
tutarınız hesabınıza yatırılacaktır. 
Ürün iade işlemlerinde kargo bedelinin iadesi yapılmaz. Sipariş edilen ürün hatası 
müşteri kullanımından oluşmuşsa veya ürün kullanılmışsa ürünün iadesi ve değişimi 
yapılmaz. 
Ürün iadesi ve değiştirme şartları olarak, 4077 sayılı Tüketicinin Korunması Hakkında 
Kanun gereği uygulamalar esastır. 
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">MADDE – 5 TESLİMAT BİLGİLERİ</h2>
        <p>
        Siparişleriniz, banka onayı alındıktan sonra gün içerisinde kargoya teslim edilir. Teslimat 
adresinin uzaklığına göre de, yasal 30 günlük süreyi aşmamak koşulu ile, her bir ürün 
için ALICI’nın yerleşim yerinin uzaklığına bağlı olarak kargo şirketi 1-3 gün içerisinde 
siparişinizi size ulaştıracaktır. 
Tarafımızdan kaynaklanan bir aksilik olması halinde ise, size üyelik bilgilerinizden yola 
çıkılarak haber verilecektir. Bu yüzden üyelik bilgilerinizin eksiksiz ve doğru olması 
önemlidir. 
Bayram ve tatil günlerinde teslimat yapılmamaktadır. Satın aldığınız ürünler, bir teyit e
postası ile tarafınıza bildirilecektir. Seçtiğiniz ürünlerden herhangi birinin stokta mevcut 
olmaması durumunda konu ile ilgili bir e-posta size yollanacak ve ürünün stoklara 
gireceği tarih tarafınıza bildirilecektir.
        </p>

      </section>

     
    </div>
  );
};

export default MssPage;
